import '@hapana/shared/utils/type-defs.util'

/** @type {Styles} */

export const styles = {
  thickDivider: {
    backgroundColor: 'gray.3',
    maxHeight: 24,
    border: 0,
    borderTop: (theme) => `1px solid ${theme.palette.gray[8]}`,
    textAlign: 'left',
    paddingY: 0.5,
  },
  searchContainer: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'gray.3',
    border: 0,
    paddingY: 0.5,
  },
  dialogContent: { padding: 4 },
  mostRecent: { marginBottom: 2 },
  previousCheckIns: {
    marginBottom: 2,
  },
  previousCheckInsTitle: { marginRight: 1 },
  loading: {
    display: 'flex',
    justifyContent: 'center',
  },
  loadingContainer: {
    mt: 2,
  },
  mostRecentTitle: { marginRight: 1 },
  userIcon: {
    fontSize: 40,
    color: 'gray.16',
  },
  icon: {
    color: 'gray.40',
    marginLeft: 3.5,
    marginRight: 1.25,
    fontSize: 16,
  },
  searchHelperText: {
    alignItems: 'center',
    lineHeight: 1.33,
  },
  tabs: {
    tabListContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottomColor: 'gray.8',
      borderBottomStyle: 'solid',
      borderBottomWidth: 1,
      paddingRight: 3,
    },
    buttonsContainer: {
      display: 'flex',
      gap: 1,
    },
    indicator: {
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: 'transparent',
      '& > span': {
        borderRadius: '100px 100px 0 0',
        width: '100%',
        backgroundColor: 'primary.main',
      },
    },
    tabList: {
      paddingLeft: 1,
      '& .MuiTabs-flexContainer': {
        display: 'unset',
      },
      display: 'flex',
      flexWrap: 'wrap',
    },
    tab: {
      color: 'gray.64',
      fontSize: 14,
      flex: '1 0 13.33%',
      whiteSpace: 'normal',
      overflow: 'hidden',
      textAlign: 'center',
      paddingY: 2.75,
      paddingX: 2,
      height: 'auto',
      '&.Mui-disabled': {
        color: 'gray.40',
      },
      '&.Mui-selected': {
        color: 'primary.main',
      },
    },
    tabPanel: {
      color: 'gray.64',
      padding: 0,
    },
  },
}
